export const stepKycOrders = {
  non_individual_online: [
    "business_details",
    "add_ar",
    "bid_details",
    "ar_declaration",
    "t_&_c",
    "e_sign",
    "completed",
  ],
  non_individual_offline: [
    "business_details",
    "add_ar",
    "bid_details",
    "ar_declaration",
    "t_&_c",
    "bid_application_download",
    "approver_details",
    "completed",
  ],
  individual_offline: [
    "offline_kyc",
    "bid_details",
    "t_&_c",
    "bid_application_download",
    "approver_details",
    "completed",
  ],
  individual_online: [],
  joint_individual_primary: [
    "online_kyc",
    "joint_proof",
    "bid_details",
    "t_&_c",
    "e_sign",
    "wait_for_consent",
    "completed",
  ],
  joint_individual_primary_online: [
    "online_kyc",
    "joint_proof",
    "bid_details",
    "t_&_c",
    "e_sign",
    "wait_for_consent",
    "completed",
  ],
  joint_individual_viewer: ["online_kyc", "t_&_c", "e_sign", "completed"],
  joint_individual_primary_offline: [
    "offline_kyc",
    "joint_proof",
    "bid_details",
    "t_&_c",
    "bid_application_download",
    "approver_details",
    "wait_for_consent",
    "completed",
  ],
  joint_individual_viewer_offline: [
    "offline_kyc",
    "t_&_c",
    "approver_details",
    "completed",
  ],
};
